export { default } from './PageMeta';
export type { MetaData } from './PageMeta.types';
